

export const GAME_ALLOWED_PROJECTS = __GAME_ALLOWED_PROJECTS__;


export const LEYA_ED_USER_DETAILS_EXTERNAL_URL = __LEYA_ED_USER_DETAILS_EXTERNAL_URL__;

export const LEAP_USER_DETAILS_EXTERNAL_URL = __LEAP_USER_DETAILS_EXTERNAL_URL__;

export const LEAP_AUTH_CLIENT_REDIRECT_URI = __LEAP_AUTH_CLIENT_REDIRECT_URI__;
export const LEAP_AUTH_CLIENT_SECRET = __LEAP_AUTH_CLIENT_SECRET__;
export const LEAP_AUTH_CLIENT_SCOPE = __LEAP_AUTH_CLIENT_SCOPE__;
export const LEAP_AUTH_CLIENT_ID = __LEAP_AUTH_CLIENT_ID__;
export const LEAP_API_BASE_URL = __LEAP_API_BASE_URL__;


export const ORFF_HERO_API_BASE_URL = __ORFF_HERO_API_BASE_URL__;


export const USER_ACCOUNT_SESSION_NAMESPACE = __USER_ACCOUNT_SESSION_NAMESPACE__;
export const LEAP_AUTH_SESSION_NAMESPACE = __LEAP_AUTH_SESSION_NAMESPACE__;
export const SESSION_LOCAL_STORAGE_KEY = __SESSION_LOCAL_STORAGE_KEY__;

export const GOOGLE_ANALYTICS_MESSAGING_SENDER_ID = __GOOGLE_ANALYTICS_MESSAGING_SENDER_ID__;
export const GOOGLE_ANALYTICS_MEASUREMENT_ID = __GOOGLE_ANALYTICS_MEASUREMENT_ID__;
export const GOOGLE_ANALYTICS_STORAGE_BUCKET = __GOOGLE_ANALYTICS_STORAGE_BUCKET__;
export const GOOGLE_ANALYTICS_AUTH_DOMAIN = __GOOGLE_ANALYTICS_AUTH_DOMAIN__;
export const GOOGLE_ANALYTICS_PROJECT_ID = __GOOGLE_ANALYTICS_PROJECT_ID__;
export const GOOGLE_ANALYTICS_API_KEY = __GOOGLE_ANALYTICS_API_KEY__;
export const GOOGLE_ANALYTICS_APP_ID = __GOOGLE_ANALYTICS_APP_ID__;